import React, { useState } from 'react'
import { graphql } from 'gatsby'
import styled from 'styled-components'

import SEO from '../../components/SEO'
import PusherDesignNavbar from '../../components/Chameleon/PusherDesignNavbar'
import Menu from '../../components/Chameleon/Menu'
import ChameleonContent from '../../components/Chameleon/ChameleonContent'
import Footer from '../../components/Footer'

import Container from '../../styles/Container'

const CustomContainer = styled(Container)`
  padding-top: 32px;
  padding-bottom: 32px;
  @media (min-width: ${(p) => p.theme.breakpointLg}) {
    display: flex;
    padding-bottom: 64px;
    padding-top: 64px;
  }
`

const Wrapper = styled.div`
  ${(p) => !p.mobileMenuIsHidden && 'display: none;'}
  @media (min-width: ${(p) => p.theme.breakpointLg}) {
    display: block;
    width: 100%;
  }
`

const ChameleonPage = ({ data }) => {
  const global = data?.allPrismicGlobal?.nodes?.[0]?.data
  const showHiringLabel = global?.show_hiring_label

  const [currentSection, setCurrentSection] = useState('Introduction')
  const [mobileMenuIsHidden, setMobileMenuIsHidden] = useState(true)

  return (
    <>
      <SEO title="Pusher | Pusher Design | Chameleon" image="https://pusher.com/images/pusher-design.png" />
      <PusherDesignNavbar mobileMenuIsHidden={mobileMenuIsHidden} setMobileMenuIsHidden={setMobileMenuIsHidden} />
      <CustomContainer>
        <Menu
          currentSection={currentSection}
          setCurrentSection={setCurrentSection}
          mobileMenuIsHidden={mobileMenuIsHidden}
          setMobileMenuIsHidden={setMobileMenuIsHidden}
        />
        <Wrapper mobileMenuIsHidden={mobileMenuIsHidden}>
          <ChameleonContent currentSection={currentSection} setCurrentSection={setCurrentSection} />
        </Wrapper>
      </CustomContainer>
      <Wrapper mobileMenuIsHidden={mobileMenuIsHidden}>
        <Footer showHiringLabel={showHiringLabel} />
      </Wrapper>
    </>
  )
}

export default ChameleonPage

export const query = graphql`
  query PusherDesignChameleonPageQuery {
    allPrismicGlobal {
      nodes {
        data {
          show_hiring_label
          show_banner
          banner_text {
            richText
          }
          banner_label
        }
      }
    }
  }
`
